@let localMarker = marker();
@let localRoom = room();
@let localCalification = calification();
@let localQualification = qualification();
<div
  class="row px-3 {{
    localCalification && localQualification ? 'pt-2' : 'pt-3'
  }} item-profile-detail pb-2"
>
  <!-- <ng-container *ngIf="showButtonReservation">
    <div class="col-12 p-0">
      <div class="offer text-white px-2 py-1 mb-2" style="background: var(--RAColor)">
        <img src="assets/img/icons/offer.svg" class="me-2" alt="" />
        <span>
          <strong>Oferta especial:</strong> Descuento del 30% en reservas para 1
          persona
        </span>
      </div>
    </div>
  </ng-container> -->
  <div class="col-12 p-0 px-md-2 d-flex flex-column gap-2 mb-1">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div>
        @if (!localMarker || localRoom) {
          <h2 class="dark-blue-text d-inline me-2">{{ name() }}</h2>
        }
        @if (localMarker && !localRoom) {
          <img class="me-2 object-fit-contain" height="33px" src="{{ logo_geomarker() }}" />
          <h2 class="dark-blue-text d-inline me-2">{{ name() }}</h2>
        }
      </div>

      @if (localMarker && !localRoom && showButtonReservation()) {
        <button class="light-green d-none d-sm-block px-5 py-2" (click)="goToBookingForm()">
          {{ '$reserve' | translate }}
        </button>
      }
    </div>

    <div class="d-flex align-items-center flex-wrap row-gap-2 column-gap-4">
      @if (localCalification && !localRoom) {
        <app-rating
          class="d-block ms-0"
          style="cursor: context-menu"
          [qualification]="localQualification"
          [disabled]="true"
        />
      }
    </div>

    @if (localCalification && !localRoom) {
      <app-valoration class="valoration" [valuations]="valorations()" />
    }
  </div>
</div>

@let localImages = images();
<div class="row item-profile-detail">
  <div id="item-profile-carousel" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
      @if (localImages) {
        <ngb-carousel
          (slide)="getIndex($event)"
          [showNavigationArrows]="true"
          [showNavigationIndicators]="false"
        >
          @for (image of localImages; track image) {
            <ng-template ngbSlide id="{{ $index }}">
              @if (image.is_360) {
                <div class="d-block img-full adjust-galery" [id]="'carousel-image-' + $index"></div>
              }
              @if (image.video && indexSelected() === $index) {
                <div class="d-block img-full adjust-galery">
                  <app-youtube-video [full]="true" [videoEmbed]="image.video" />
                </div>
              }

              @if (!image.is_360 && !image.video) {
                <img
                  [style.cursor]="'zoom-in'"
                  [style.max-height]="'600px'"
                  class="d-block img-full adjust-galery"
                  [src]="image?.image | cdnUrl: 1200 : true"
                  (click)="
                    galleryLightbox() ? (!image.is_360 ? lightbox.open($index) : null) : null
                  "
                  alt="Random slide"
                />
              }
              <div class="carousel-caption w-100">
                <p class="ts ps-2">{{ image?.title }}</p>
                <!-- <i class="inm-icon-search"></i> -->
              </div>
            </ng-template>
          }
        </ngb-carousel>
      }
    </div>
    <ol class="carousel-indicators">
      @for (image of localImages; track image) {
        <li
          (click)="selectImage($index)"
          class="list-unstyled mx-2"
          [class.active]="$index === indexSelected()"
        >
          <img
            class="d-block img-fluid adjust w-100"
            style="height: 54px"
            [lazyLoad]="image.video ? 'img/youtube-icon.png' : (image.image | cdnUrl: 200 : true)"
          />
        </li>
      }
    </ol>
  </div>

  @if (localMarker && !localRoom && showButtonReservation()) {
    <div class="reserve px-5 d-flex d-sm-none align-items-center justify-content-center">
      <button class="light-green full" (click)="goToBookingForm()">
        {{ '$reserve' | translate }}
      </button>
    </div>
  }
</div>
